<template>
  <div>
       <div data-app="slider-game-tens">
       <slot></slot>
 </div>
  </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
export default {
  data: function () {
    return {
      sliderNumber: 0
    }
  },
  methods: {
    infoSlider () {
      const els = document.querySelectorAll('[data-app="slider-game-tens"]');

      if (els.length) {
        const slider = tns({
          container: '[data-app="slider-game-tens"]',
          items: 1,
          center: false,
          autoplay: false,
          edgePadding: 0,
          autoplayButtonOutput: true,
          gutter: 20,
          loop: false,
          nav: true,
          controlsText: ['', '']
        });
        slider.events.on('indexChanged', () => {
          const sliderInfos = slider.getInfo();
          this.$emit('slider-number', sliderInfos.displayIndex);
        });
      }
    }
  },
  mounted () {
    this.infoSlider();
  }
}
</script>
